import Image from 'next/image';
import Logo from 'public/logo.svg';
import { CarModel } from 'types/Car';
import { Card, CardImage, ModelName } from './ModelCard.styled';

type Props = {
  data: CarModel;
  onClick: any;
};

export default function ModelCard({ data, onClick }: Props) {
  return (
    <Card onClick={onClick}>
      <CardImage>
        <Image src={data.image || Logo} width={170} height={92} alt="car model" objectFit="contain" />
      </CardImage>
      <ModelName>{data.name}</ModelName>
    </Card>
  );
}
